module.exports = __webpack_public_path__ + "img/home-title2.ea92a82a.png";